import APIClient , { failSafe , makeCancellableAPIRequest } from "./index";
import _ from 'lodash';
import moment from "moment";
import { getStartAndEndDateForQuickOption } from "utils/dateUtils";

export const AppSecToolsIntegrationAPI = {
    getDiscoveredTools(){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/appsec-tools/discover`
        )
    },
    getToolsMetaData(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/meta`
        )
    },
    // generic
    getToolsConfiguration(toolName){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/configuration/${toolName}`
        )
    },
    //coverity 
    getCoverityLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/v1/coverity/login_details",
        )
    },
    postCoverityLoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/v1/coverity/login_details",
            {
                data,
            }
        )
    },
    updateCoverityLoginDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/v1/coverity/login_details",
            {
                data,
            }
        )
    },
    getCoverityProjects(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/v1/coverity/projects"
        )
    },
    deleteCoverityConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/v1/coverity/${id}`,
        )
    },
    deleteHackerOneConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/hackerone/${id}`,
        )
    },
    getCoverityConfiguration(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/v1/coverity"
        )
    },
    postCoverityConfiguration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/v1/coverity",
            {
                data,
            }
        )
    },
    //fortify
    getFortifyLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/fortify/login_details",
        )
    },
    postFortifyLoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/fortify/login_details",
            {
                data,
            }
        )
    },
    updateFortifyLoginDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/fortify/login_details",
            {
                data,
            }
        )
    },
    getFortifyReleases(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/fortify/applications",
        )
    },
    deleteFortifyConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/fortify/${id}`,
        )
    },
    getFortifyConfiguration(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/fortify",
        )
    },
    postFortifyConfiguration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/fortify",
            {
                data,
            }
        )
    },
    postHackerOneLoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/hackerone/login_details",
            {
                data,
            }
        )
    },
    updateHackerOneLoginDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/hackerone/login_details",
            {
                data,
            }
        )
    },
    postHackerOneConfiguration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/hackerone",
            {
                data,
            }
        )
    },
    getHackerOneReleases(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/hackerone/projects",
        )
    },
    getHackerOneConfiguration(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/generic/configurations/HACKERONE",
        )
    },
    getHackerOneLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/hackerone/login_details",
        )
    },
    postNowSecureLoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/nowsecure/login_details",
            {
                data,
            }
        )
    },
    updateNowSecureLoginDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/nowsecure/login_details",
            {
                data,
            }
        )
    },
    postNowSecureConfiguration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/nowsecure",
            {
                data,
            }
        )
    },
    getNowSecureReleases(queryParams){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/nowsecure/applications",
            {
                params: queryParams
            }
        )
    },
    getNowSecureLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/nowsecure/login_details",
        )
    },
    deleteNowSecureConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/nowsecure/${id}`,
        )
    }
}

const ToolsIntegrationsAPI = {
    exportSecurityToolConfigData(data, toolName){
        // get TimeZone
        const timeZone = moment.tz.guess();
        
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/download/v2/csv/${toolName}`,
            {
                data: {
                    ...data,
                    timeZone
                }
            }
        )
    },
    webHookToolConfigurations(data){
        return makeCancellableAPIRequest(
            "POST",
            "user/tools/generic/configurations/webhook",
            {
                data,
            }
        )
    },
    getSecuritytoolWebhookToken(data, toolName) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/configurations/${toolName}/webhook`,
            {
                data
            }
        )
    },
    getRoute53Integrate(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/route53/integrate"
        )
    },
    getAWSIntegrate(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/awsInfra/integrate"
        )
    },
    getRoute53Listing(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/route53"
        )
    },
    getAWSIntegrationListing(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/awsInfra/accounts"
        )
    },
    getAWSResourceListing(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/awsInfra"
        )
    },
    updateAWSResourceMapping(params){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/awsInfra`,
            {
                params,
            }
        )
    },
    syncAWSResource(){
        return makeCancellableAPIRequest(
            "POST",
            `/api/awsInfra`
        )
    },
    updateRoute53(data, id){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/awsInfra/records/${id}`,
            {
                data,
            }
        )
    },
    integrateRoute53(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/awsInfra/records",
            {
                data,
            }
        )
    },
    deleteRoute53(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/awsInfra/records/${id}`
        )
    },
    getRoute53hostedZone(){
        return makeCancellableAPIRequest(
            "GET",
            `user/route53/hostedZones`
        )
    },
    getRoute53hostedZoneRecord(id){
        return makeCancellableAPIRequest(
            "GET",
            `api/awsInfra/hostedZone/${id}/records`
        )
    },
    getToolAuditLog(toolName,page = 0){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/configurations/${toolName}/auditlog?page=${page}`,
        )
    },
    integrateTicketSystemTool(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tickets/jira/configuration",
            {
                data,
            }
        )
    },
    updateTicketSystemToolMapping(data, id){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tickets/jira/configuration/${id}`,
            {
                data,
            }
        )
    },
    integrateAzure(data){
        data.ticketSystemType = "AZURE_BOARD";
        return failSafe(
            APIClient.post("/user/tickets/jira/configuration", data)
        )
    },
    integrateServiceNow(data){
        data.ticketSystemType = "SERVICE_NOW";
        return failSafe(
            APIClient.post("/user/tickets/jira/configuration", data)
        )
    },
    getAzurePriorities({authToken}) {
        const data = {
            "ticketSystemType" : "AZURE_BOARD",
            "apiToken": authToken
        }
        return makeCancellableAPIRequest(
            "POST",
            "user/tickets/jira/priorities",
            {
                data
            },
            false
        )
    },
    getTicketSystemToolPriorities(data) {
        return makeCancellableAPIRequest(
            "POST",
            "user/tickets/jira/priorities",
            {
                data
            }
        )
    },
    getTicketSystemToolSeverities(params) {
        return makeCancellableAPIRequest(
            "GET",
            "user/tickets/jira/ticketSeverities",
            {
                params
            }
        )
    },
    getZendeskOrganizations({loginConfigId}) {
        return makeCancellableAPIRequest(
            "GET",
            `api/v2/tickets/${loginConfigId}/organizations`,
        )
    },
    getZendeskForms({loginConfigId}) {
        return makeCancellableAPIRequest(
            "GET",
            `api/v2/tickets/${loginConfigId}/forms`,
        )
    },
    getTicketSystemToolIssueTypes(data) {
        return makeCancellableAPIRequest(
            "POST",
            "user/tickets/jira/issueTypes",
            {
                data
            },
        )
    },
    getFreshServiceIssueTypes(data,params) {
        return makeCancellableAPIRequest(
            "POST",
            "user/tickets/jira/issueTypes",
            {
                data,
                params
            },
        )
    },
    validateBranch(data, branch, showDefaultMessage = false) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/git/branch/${branch}`,
            {
                data
            },
            showDefaultMessage
        )
    },
    getOrganizations(authToken){
        return makeCancellableAPIRequest(
            "GET",
            "user/tickets/jira/organisations",
            {
                headers: {
                  authToken
                }
            },
            false
        )
    },
    getJiraCloseTransitionStatusOptions: (data) => makeCancellableAPIRequest(
        "POST",
        "user/tickets/jira/status",
        {
            data
        }
    ),
    gitBranchValidation(data, showDefaultMessage = false) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/git/branch-validation`,
            {
                data
            },
            showDefaultMessage
        )
    },
    getAzureProjects({authToken, organisation}){
        const data = {
            "ticketSystemType" : "AZURE_BOARD",
            "apiToken": authToken,
            organisation
        }
        return makeCancellableAPIRequest(
            "POST",
            `user/tickets/jira/projects/`,
            {
                data
            },
            false
        )
    },
    getAzureBoardAreas(params){
        return makeCancellableAPIRequest(
            "GET",
            '/user/tickets/jira/areas',
            {
                params
            }
        )
    },
    getTicketSystemToolProjects(loginConfigId, params){
        const data = { loginConfigId };
        return makeCancellableAPIRequest(
            "POST",
            '/user/tickets/jira/projects',
            {
                data,
                params
            }
        )
    },
    getJiraLabels(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tickets/jira/labels",
            {
                data
            }
        )
    },
    integrateGithub(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/github",
            {
                data,
            }
        )
    },
    getInstallations() {
        return makeCancellableAPIRequest(
            "GET",
            "user/tools/github/installation"      
        )
    },
    getInstallationsByRepoType(repoType) {
        // since Github is now ticketing system, repoType param is expected and object
        // to be fetched from the object { ticketSyetsm: "GITHUB" } 
        let repoTypeParam = repoType;
        if(_.isPlainObject(repoType)){
            repoTypeParam = repoType.ticketSystem;
        }
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/git/gitInstallation/repoType/${repoTypeParam}`
        )
    },
    deleteGitInstallations(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/git/gitInstallation/${id}`,
        )
    },
    getRepos(data, params) {
        return makeCancellableAPIRequest(
            "POST",
            "api/scm/discover/repos",
            {
                data,
                params
            }      
        )
    },
    getRepoContributors(repoId) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/tools/git/repo/${repoId}/contributors`
        )
    },
    getReposFilters(){
        return makeCancellableAPIRequest(
            "GET",
            "api/scm/discover/repo-filters"
        )
    },
    postGithubEnterpriseDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/github/enterprise",
            {
                data,
            }
        )
    },
    updateGithubEnterpriseDetails(data, id){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/github/enterprise/${id}`,
            {
                data,
            }
        )
    },
    deleteGithubEnterpriseDetails(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/github/enterprise/${id}`,
        )
    },
    putGithubEnterpriseDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/github/enterprise",
            {
                data,
            }
        )
    },
    postGithubEditRepositoryDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/git/token",
            {
                data,
            }
        )
    },
    getGitRepos(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/token"
        )
    },
    putGithubEditRepositoryDetails(id, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/git/token/${id}`,
            {
                data,
            }
        )
    },
    deleteRepositoryMapping(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/git/token/${id}`
        )
    },
    testJiraIntegration(data){
        data.ticketSystemType = "JIRA";
        return makeCancellableAPIRequest(
            "POST",
            "/user/test/jiraticket",
            {
                data,
            }
        )
    },
    testAzureIntegration(data) {
        data.ticketSystemType = "AZURE_BOARD";
        return failSafe(
            APIClient.post("user/test/user", data)
        )
    },
    testServiceNowIntegration(data) {
        data.ticketSystemType = "SERVICE_NOW";
        return failSafe(
            APIClient.post("/user/test/jiraticket", data)
        )
    },
    deleteTicketSystemToolConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tickets/jira/configuration/${id}`,
        )
    },
    deleteCTIConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/generic/configs/${id}`,
        )
    },
    deleteBackstageConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/generic/configs/${id}`,
        )
    },

    deleteMobbSecurityConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/generic/configs/${id}`,
        )
    },
    getTicketSystemToolLoginDetails(toolName){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/configuration/login/${toolName}`,
        )
    },
    getTicketSystemToolLoginDetailsByToolNames(params){
        return makeCancellableAPIRequest(
            "GET",
            `user/tickets/jira/configuration/login/list`,
            {
                params
            }
        )
    },
    getThreatConnectLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/generic/configs/THREAT_CONNECT`,
        )
    },
    getFlashPointLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/generic/configs/FLASH_POINT`,
        )
    },
    getMadiantAdvantageLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/generic/configs/MANDIANT_ADVANTAGE`,
        )
    },
    getBackstageLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/generic/configs/BACKSTAGE`,
        )
    },

    getMobbSecurityLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/generic/configs/MOBB_SECURITY`,
        )
    },

    getTicketSystemToolLoginDetailsForId(toolName, id){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/configuration/login/${toolName}/${id}`,
        )
    },
    deleteTicketSystemToolLoginDetails(toolName, id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tickets/jira/configuration/login/${toolName}/${id}`,
        )
    },
    postTicketSystemToolLoginDetails(toolName, data){
        data.ticketSystemType = toolName;
        return makeCancellableAPIRequest(
            "POST",
            `/user/tickets/jira/configuration/login/${toolName}`,
            {
                data
            }
        )
    },
    postCTILoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/generic/configs/`,
            {
                data
            }
        )
    },
    postGenericLoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/generic/configs`,
            {
                data
            }
        )
    },
    updateGenericConfigDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/generic/configs/${data.id}`,
            {
                data
            }
        )
    },
    updateTicketSystemToolLoginDetails(toolName, data, id){
        data.ticketSystemType = toolName;
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tickets/jira/configuration/login/${toolName}/${id}`,
            {
                data
            }
        )
    },
    getTicketSystemToolDetails(params){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/configuration",
            {
                params
            }
        )
    },

    //new paginated api used to get Integrations Ticketing System config lists
    // currently search is not supported for this api when used in SELECT_WITH_PAGINATED
    // turn off search when used anywhere
    getTicketSystemToolDetailsV2(loginId, data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/v2/tickets/logins/${loginId}/configurations`,
            {
                data
            }
        )
    },
    getTicketSystemListingFilters(params){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/configuration-filters`,
            {
                params
            }
        )
    },
    getTicketSystemsByProductSubproduct(params){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/configuration/list",
            {
                params
            }
        )
    },
    getTicketSystemToolDetailsForId(id){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/configuration/${id}`,
        )
    },
    getJiraIntegrationByProductSubProduct(params){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/configuration/enabled",
            {params}
        )
    },
    getTicketTemplateByConfigId(configId){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/template",
            {
                params: { configId }
            }
        )
    },
    createOrUpdateTicketTemplate(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tickets/jira/template",
            {
                data
            }
        )
    },
    getGithubRepoDetails(installationId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/github/repos/${installationId || ""}`
        )
    },
    createGitInstallation(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/git/gitInstallation`,
            {
                data,
            }
        )
    },
    createGitInstallationsBulk(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/git/installation/bulk`,
            {
                data,
            }
        )
    },
    updateGitInstallation(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/git/gitInstallation/${data.id}/token`,
            {
                data,
            }
        )
    },
    getRepoDetails(installationId, params){
        let queryParams = params;
        if(params.filters?.name){
            queryParams = {
                ..._.omit(params.filters, ["name"]),
                name: params.filters.name
            }
        }
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/git/gitInstallation/${installationId}/repos`,
            {   
                params: queryParams
            }
        )
    },
    getRepoFilters(installationId, params) {
        const queryParams = params;
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/git/repos-filters/${installationId}`,
            {
                params: queryParams
            }
      )  
    },
    createGitMapping(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/git/repo`,
            {
                data,
            }
        )
    },
    deleteGitMapping(repoId){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/git/repo/${repoId}`,
        )
    },
    updateJiraIntegration(id, data){
        data.ticketSystemType = "JIRA";
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tickets/jira/configuration/${id}`,
            {
                data,
            }
        )
    },
    updateTicketSystemToolConfigIntegration(id, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tickets/jira/configuration/enable/${id}`,
            {
                data,
            }
        )
    },
    updateAzureIntegration(id, data){
        data.ticketSystemType = "AZURE_BOARD";
        return failSafe(
            APIClient.put(`/user/tickets/jira/configuration/${id}`, data)
        )
    },
    updateServiceNowIntegration(id, data){
        data.ticketSystemType = "SERVICE_NOW";
        return failSafe(
            APIClient.put(`/user/tickets/jira/configuration/${id}`, data)
        )
    },
    getBuildToolsStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/status",
        )
    },
    getTicketingUsers(params={}){
        params = _.isObject(params) ? params : { configId: params}
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/users/`,
            {
                params
            }
        )
    },
    getTicketingUser(params={}){
        params = _.isObject(params) ? params : { configId: params}
        return makeCancellableAPIRequest(
            "GET",
            `/api/v2/tickets/user`,
            {
                params
            }
        )
    },
    getGithubIntegrationDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/github"
        )
    },
    getGithubEnterpriseIntegrationDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/github/enterprise"
        )
    },
    getGithubToolsAutoMappingConfigs(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config",
            {
                params: {
                    configType: "AUTO_CREATE_GITHUB_TOOLS_CONFIG"
                }
            }
        )
    },
    getGithubInstallationConfigs(configID, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/git/installation/${configID}/config`,
            {
                data
            }
        )
    },
    updateGithubToolsAutoMappingConfigs(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/tenant-config",
            {
                data: {
                    data,
                    configType: "AUTO_CREATE_GITHUB_TOOLS_CONFIG"
                }
            }
        )
    },
    postGithubOrganisations(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/github/orgs",
            {
                data,
            }
        )
    },
    syncDependabotPRs(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config",
            {
                params: {
                    configType: "SYNC_DEPENDABOT_PRS"
                }
            }
        )
    },
    updateDependabotSyncPRs(value){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType: "SYNC_DEPENDABOT_PRS",
                    data: value
                }
            }
        )
    },
    syncToolPRs(configType){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config",
            {
                params: {
                    configType
                }
            }
        )
    },
    updateToolSyncPRs(value, configType){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant-config",
            {
                data: {
                    configType,
                    data: value
                }
            }
        )
    },
    syncRepos(type){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/github/repo-sync?repoType=${type}`,
        )
    },
    // checkmarx
    getCheckmarxLoginDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/v1/checkmarx/login_details",
        )
    },
    postCheckmarxLoginDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/v1/checkmarx/login_details",
            {
                data,
            }
        )
    },
    updateCheckmarxLoginDetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/v1/checkmarx/login_details",
            {
                data,
            }
        )
    },
    getCheckmarxProjects(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/generic/configurations/CHECKMARX/project",
        )
    },
    getCheckmarxConfiguration(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/generic/configurations/CHECKMARX"
        )
    },
    postCheckmarxConfiguration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/v1/checkmarx",
            {
                data,
            }
        )
    },
    deleteCheckmarxConfiguration(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/v1/checkmarx/${id}`,
        )
    },
    getAppIntToolsStatus(params = {}){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/integration-tools/status",
            {
                data: params
            }
        )
    },
    getAppSecToolsStatus(params = {}){
        return makeCancellableAPIRequest(
            "POST",
            "/api/dashboard/tools/appsec/status",
            {
                data: params
            }
        )
    },
    updateAppSecToolsStatus(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/tools/appsec-tools/status",
            {
                data
            }
        )
    },
    getAppSecToolBidirectionalSettingStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/appsec-tools/settings",  
        )
    },
    getAppSecToolConfiguration(toolName){
        toolName = toolName.toUpperCase().replace(' ','_');
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/configuration/${toolName}`
        )
    },
    getVersion(toolName){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/configurations/${toolName}/version`,
        )
    },
    postToolsConfiguration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/configuration",
            {
                data,
            }
        )
    },
    postGenericToolsConfiguration(data, showError){
        return makeCancellableAPIRequest(
            "POST",
            "user/tools/generic/configurations",
            {
                data,
            },
            showError
        )
    },
    getGenericConfigurationsByToolName(toolname, queryParams){
        const { toolType, ...restParams } = queryParams
        // let transformedFilter = {};
        if(!_.isEmpty(restParams)){
            [restParams.sortColumn, restParams.sortOrder] = (restParams.sort || "").split(",")
                if(restParams.sortColumn === "" ) {
                    delete restParams.sortColumn
                }
                if(restParams.sortOrder === "") {
                    delete restParams.sortOrder
                }
                if(_.isEmpty(restParams.filters)){
                    delete restParams.filters
                }
                
                if(restParams.filters){
                    restParams.filters = _.omitBy(restParams.filters, _.isNull);
                    // transformedFilter =  Object.keys(restParams.filters).reduce((acc, key) => ({ ...acc, [`filters[${key}]`]: restParams.filters[key].join(', ') }), {});
                    // delete restParams.filters;
                }   
        }
        /**
         * URLSearchParams to get query string
         * omitBy use to filter undefined value
         */
        // const urlParams = new URLSearchParams({..._.omitBy((restParams || {}), _.isUndefined), ...transformedFilter, toolType});
        const data = {toolType, ...restParams};
        return makeCancellableAPIRequest(
            "POST",
            `user/tools/generic/configurations/${toolname}`,
            {
                data
            }
        )
    },

    getGenericEvolvedConfigurationsByToolName(toolname, data){
        if(data.filters){
            const dateFilters = ["lastConnected", "scanLastRun"];
            dateFilters.forEach(key => {
                if(data.filters[key] && data.filters[key].length === 1){
                    data.filters[key] = getStartAndEndDateForQuickOption({
                      label: data.filters[key][0],
                      utcString: true,
                    });
                }
            })
        }
        return makeCancellableAPIRequest(
            "POST",
            `user/tools/generic/configurations/${toolname}`,
            {
                data,
            }
        )
    },

    getGenericEvolvedFilteredConfigurationsByToolName(toolname, queryParams){
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/generic/configurations/filters/${toolname}/`,
            {
                params: queryParams
            } 
        )
    },

    getGenericProjectByToolName(toolname, queryParams, showDefaultMessage = true){
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/generic/configurations/${toolname}/project`,
            {
                params: queryParams
            },
            showDefaultMessage
        )
    },
    getGenericProjectByToolNameV2(toolname, data, showDefaultMessage = true){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/v2/generic/configurations/${toolname}/project`,
            {
                data
            },
            showDefaultMessage
        )
    },
    getJiraSecurityToolMappingToolFields(queryParams){
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/generic/configuration/Jira/tool-fields`,
            {
                params: queryParams
            },
        )
    },
    deleteGenericConfigurationByToolName(toolname, id){
        return makeCancellableAPIRequest(
            "DELETE",
            `user/tools/generic/configurations?tool_name=${toolname}&id=${id}`,
        )
    },
    updateGenericConfigurationByToolName(data, showError){
        return makeCancellableAPIRequest(
            "PUT",
            `user/tools/generic/configurations`,
            {
                data,
            },
            showError
        )
    },
    updateWebhookConfigurationByToolName(data){
        return makeCancellableAPIRequest(
            "PUT",
            "user/tools/generic/configurations/webhook",
            {
                data,
            }
        )
    },
    getAppSecTool(toolName){
        // Need to remove this once generic API implementated
        toolName = toolName.toLowerCase().replace(' ','_');
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/${toolName}`
        )
    },
    postGenericLoginDetail(data,toolName){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/login_details/${toolName}`,
            {
                data,
            }
        )
    },
    getGenericLoginDetail(toolName){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/login_details/${toolName}`
        )
    },
    updateGenericLoginDetail(data,toolName, loginConfigId){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/generic/login_details/${toolName}/${loginConfigId}`,
            {
                data,
            }
        )
    },
    deleteGenericLoginDetail(toolName, id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/generic/login_details/${toolName}/${id}`
        )
    },
    getGitLabDetails() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/token/repoType/GITLAB",
        )
    },
    getBitbucketDetails() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/token/repoType/BITBUCKET",
        )
    },

    postBitBucketDetails(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/bitbucket/quick-install",
            {
                data,
            }
        )
    },

    updateBitBucketDetails(id, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/bitbucket/quick-install/${id}`,
            {
                data,
            }
        )
    },

    postWorkSpaces(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/git/workspaces",
            {
                data,
            }
        )
    },
    azureReposListing() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/token/repoType/AZURE_REPOS",
        )
    },
    azureReposProjects(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/git/projects",
            {
                data,
            }
        )
    },
    postGitLabDetail(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/git/token/",
            {
                data,
            }
        )
    },
    getWebhook(params = {}) {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/git/webhook/token",
            {
                params,
            }
        )
    },
    postTokenToValidate(data) {
        return makeCancellableAPIRequest(
            "POST",
            "user/tools/git/projects",
            {
                data,
            }
        )
    },
    postUploadUrl(data,toolName, showDefaultMessage = true){
        // get TimeZone
        const uploadTimezone = moment.tz.guess();

        return makeCancellableAPIRequest(
            "POST",
            `user/tools/generic/configurations/${toolName}/upload`,
            {
                data: {
                    ...data,
                    uploadTimezone
                }
            },
            showDefaultMessage
        )
    },
    getSlackWorkSpaceDetails(scope){
        let path = "/user/tools/slack/workspace";
        if (scope) {
            path += "?scope=" + scope;
        }
        return makeCancellableAPIRequest(
            "GET",
            path,
        )
    },  
    getSlackIntegrationDetails(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/slack",
        )
    },
    getSlackIntegrationDetailsById(id, showDefaultMessage){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/slack/${id}`,
            {},
            showDefaultMessage
        )
    },
    createSlackIntegration(data){
        return makeCancellableAPIRequest(
            'POST',
            "/user/tools/slack",
            {
                data
            }
        )
    },
    updateSlackIntegrationDetails(data, id){
        return makeCancellableAPIRequest(
            'PUT',
            `/user/tools/slack/${id}`,
            {
                data,
            }
        )
    },
    getSlackChannels(id, showDefaultMessage){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/slack/workspace/${id}/channels`,
            {},
            showDefaultMessage
        )
    },
    getSlackMembers(id, showDefaultMessage){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/slack/workspace/${id}/members`,
            {},
            showDefaultMessage
        )
    },
    getSlackChannelsWithScope(id, scope, showDefaultMessage){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/slack/workspace/${id}/channels?scope=${scope}`,
            {},
            showDefaultMessage
        )
    },
    deleteSlackWorkSpace(id){
        return failSafe(
            APIClient.delete(`/user/tools/slack/workspace/${id}`)
        )
    },
    deleteSlackConfiguration(id){
        return failSafe(
            APIClient.delete(`/user/tools/slack/${id}`)
        )
    },
    getMSTeamsLoginDetails(scope){
        let path = "/user/tools/msteams/list";
        if (scope) {
            path += "?scope=" + scope;
        }
        return makeCancellableAPIRequest(
            "GET",
            path
        )
    },
    getMSTeamsConfiguration() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/msteams/configs"
        )
    },
    postMSTeamsConfigurations(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/msteams/login", 
            {
                data
            }
        )
    },
    updateMSTeamsConfiguration(data, id){
        return makeCancellableAPIRequest(
            'PUT',
            `/user/tools/msteams/login/${id}`,
            {
                data,
            }
        )
    },
    deleteMSTeamsLogin(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/msteams/login/${id}`,
        )
    },
    deleteMSTeamsConfiguration(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/msteams/${id}`,
        )
    },
    getMSTeams(id, scope){
        let path = `/user/tools/msteams/${id}/list-teams`;
        if (scope) {
            path += "?scope=" + scope;
        }
        return makeCancellableAPIRequest(
            "GET",
            path
        )
    },
    getMSTeamsChannel(id, teamId,scope){
        let path = `/user/tools/msteams/${id}/${teamId}/channels`;
        if (scope) {
            path += "?scope=" + scope;
        }
        return makeCancellableAPIRequest(
            "GET",
            path
        )
    },
    createMSTeamsIntegration(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/msteams", 
            {
                data
            }
        )
    },
    updateMSTeamIntegrationDetails(data, id){
        return makeCancellableAPIRequest(
            'PUT',
            `/user/tools/msteams/${id}`,
            {
                data,
            }
        )
    },
    getSecurityToolsDiscovery(params){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/unmapped-projects-page`,
            {
                params
            }
        )
    },
    getBlackduckHubProjectDiscovery({size,page,...data}){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/discovery/projects`,
            {
                data:data,
                params:{size,page}
            }
        )
    },
    getBlackduckHubProjectDiscoveryFilters(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/discovery/projects-filters`
        )
    },
    getCICDPipelinesDiscovery({size,page,...data}){
        return makeCancellableAPIRequest(
            "POST",
            `api/builds/jobs/discovery/list`,
            {
                data:data,
                params:{size,page}
            }
        )
    },
    getAsset(params = {}) {
        return makeCancellableAPIRequest(
            "GET",
            `/user/tool/assets`,
            {
                params
            }
        )
    },
    getAssetTags(data = {}) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tool/assets/tag-library`,
            {
                data
            }
        )
    },
    getAssetsPost(params = {}, data) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tool/assets`,
            {
                params,
                data
            }
        )
    }, 
    deleteAsset(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tool/assets/${id}`,
        )
    },
    getAssetFilters() {
        return makeCancellableAPIRequest(
            "GET",
            `/user/tool/assets/filter`,
        )
    },
    getAssetFiltersByConfigId(configId) {
        return makeCancellableAPIRequest(
            "GET",
            `/user/tool/assets/filter`,
            {
                params: {
                    configId
                }
            }
        )
    },
    syncAsset(toolName) {
        return makeCancellableAPIRequest(
            "GET",
            `/user/tool/assets/sync?toolAssetName=${toolName}`,
        )
    },
    mapAssetTools(data = {}) {
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tool/assets`,
            {
                data
            }
        )
    },
    getConfigCount() {
        return makeCancellableAPIRequest(
            "GET",
            `user/tool/assets/count?toolName=LEAN_IX`,
        )
    },
    getSecurityToolsDiscoveryFilters(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/projects-filters`
        )
    },
    postToolRunOnDemand(toolName) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/${toolName}/unmapped-projects`,
        )
    },
    getAutomoxConfigurations(){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tools/automox/`
        )
    },
    postAutomoxConfigurations(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/tools/automox/", 
            {
                data
            }
        )
    },
    updateAutomoxConfigurations(id, data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/automox/${id}`, 
            {
                data
            }
        )
    },
    deleteAutomoxConfigurations(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/tools/automox/${id}`,
        )
    },
    applyAutomoxPatch(configurationId, data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/automox/${configurationId}/patchFinding`, 
            {
                data
            }
        )
    },
    startToolScan(toolName, configId){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/start-tool-scan/?toolName=${toolName}&configId=${configId}`
        )
    },
    getJiraAuthURL(data){
        return makeCancellableAPIRequest(
            "POST",
            '/user/tickets/jira/request/token', 
            {
                data
            }
        )
    },
    getSnykExploitOptions(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/snyk-exploit-maturity`
        )
    },
    getFiniteStateOrganisations(token) {
        return makeCancellableAPIRequest(
            "GET",
            '/user/tools/generic/configurations/FiniteState/projectsWithToken',
            {
                params: {
                    token,
                }
            }
        )
    },

    getFiniteStateOrganisationsWithConfig(data) {
        return makeCancellableAPIRequest(
            "POST",
            '/user/tools/generic/configurations/FiniteState/projectsWithConfig/get',
            {
                data
            }
        )
    },

    getRunzeroOrgs(data){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/runzero-orgs`,
            {
                headers: data
            }
        )
    },
    getWizProjects(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/wiz/projects`,
            {
                data
            }
        )
    },
    getProjectByToolName(data, toolName){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/v2/login-details/${toolName}/project`,
            {
                data
            }
        )
    },
    checkCustomInputAllowed() {
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/custom-input-allowed"
        )
    },
    getServiceNowAssignmentGroups(loginConfigId){
        return makeCancellableAPIRequest(
            "GET", 
            `user/tickets/jira/service-now/assignmemt-groups?loginConfigId=${loginConfigId}`
        )
    },
    getServiceNowCmdbCiTables(data){
        return makeCancellableAPIRequest(
            "POST", 
            `/user/tickets/jira/discovery/tables`,
            {
                data
            }
        )
    },
    getJiraCMDBObjectTypes(data){
        return makeCancellableAPIRequest(
            "POST", 
            `/user/tool/assets/discovery/types`,
            {
                data
            }
        )
    },
    getJiraCMDBList(data){
        return makeCancellableAPIRequest(
            "POST", 
            `/user/tool/assets/cmdb/configs/list`,
            {
                data
            }
        )
    },
    saveJiraCmdbMapping(data){
        return makeCancellableAPIRequest(
            "POST", 
            `/user/tool/assets/cmdb/configs`,
            {
                data
            }
        )
    },
    deleteJiraCmdbMapping(data){
        return makeCancellableAPIRequest(
            "DELETE", 
            `/user/tool/assets/cmdb/configs`,
            {
                data
            }
        )
    },
    updateJiraCmdbMapping(data){
        return makeCancellableAPIRequest(
            "PUT", 
            `/user/tool/assets/cmdb/configs`,
            {
                data
            }
        )
    },
    deleteServiceNowCmdbCiConfig(id, data){
        return makeCancellableAPIRequest(
            "DELETE", 
            `/user/tickets/jira/configuration/discovery/SERVICE_NOW/${id}`,
            {
                data
            }
        )
    },
    createServiceNowCmdbCiConfig(data){
        return makeCancellableAPIRequest(
            "POST", 
            `user/tickets/jira/configuration/login/SERVICE_NOW`,
            {
                data
            }
        )
    },
    updateServiceNowCmdbCiConfig(data, configId){
        return makeCancellableAPIRequest(
            "PUT", 
            `user/tickets/jira/configuration/login/SERVICE_NOW/${configId}`,
            {
                data
            }
        )
    },
    getServiceNowCmdbCiAttributes(data){
        return makeCancellableAPIRequest(
            "POST", 
            ` /user/tickets/jira/discovery/attributes`,
            {
                data
            }
        )
    },
    getWorkspaces(loginConfigId){
        return makeCancellableAPIRequest(
            "GET", 
            `user/tickets/jira/workspaces?loginConfigId=${loginConfigId}`
        )
    },
    createOrupdateAlertIntegration(data){
        return makeCancellableAPIRequest(
            data.id ? "PUT" : "POST",
            `/user/api/integration` + (data.id ? `/${data.id}` : ""),
            {
                data
            }
        )
    },
    enableDisableAlertIntegration(id, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/api/integration/${id}/configuration`,
            {
                data
            }
        )
    },
    getAllAlertIntegrations(){
        return makeCancellableAPIRequest(
            "GET", 
            `/user/api/integration`
        )
    },
    getAlertIntegration(id){
        return makeCancellableAPIRequest(
            "GET", 
            `/user/api/integration/${id}`
        )
    },
    deleteAlertIntegration(id){
        return makeCancellableAPIRequest(
            "DELETE", 
            `/user/api/integration/${id}`
        )
    },
    getTicketSystemToolTeams(params){
        return makeCancellableAPIRequest(
            "GET",
            '/user/tickets/jira/teams',
            {
                params
            }
        )
    },
    getTicketTemplateByLoginConfigId(loginConfigId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/global/template/${loginConfigId}`,
        )
    },
    getUnifiedTicketTemplates(params){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/ticketUnifiedTemplates`,
            {
                params
            }
        )
    },
    createUnifiedTicketTemplate(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tickets/jira/ticketUnifiedTemplate`,
            {
                data
            }
        )
    },
    updateUnifiedTicketTemplate(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tickets/jira/ticketUnifiedTemplate/${data.id}`,
            {
                data
            }
        )
    },
    deleteUnifiedTicketTemplate(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tickets/jira/ticketUnifiedTemplate/${id}`,
        )
    },
    getUnifiedTicketTemplatesByType(params){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/ticketUnifiedTemplateDropdown`,
            {
                params
            }
        )
    },
    validateUnifiedTicketTemplateName(params = {}, showDefaultMessage = true){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tickets/jira/ticketUnifiedTemplate/validate", 
            {
                params
            },
            showDefaultMessage
        )
    },
    createOrUpdateGlobalTicketTemplate(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tickets/jira/global/template",
            {
                data
            }
        )
    },
    getAssessmentDetail(toolName, loginId, assetId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/configuration/${toolName}/assessment_detail?loginId=${loginId}&assetId=${assetId}`,
        )
    },
    syncArmorCodeAgentStatus(){
        return makeCancellableAPIRequest(
            "POST",
            `/api/ac-agent/sync`,
        )
    },
    getSecurityToolsDiscoveryCSV(params, data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/discovery/csv",
            {
                data,
                params
            }
        )
    },
    executeScanSubproduct(id, toolName, environment){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/${id}/execute-scan?toolName=${toolName}&environmentName=${environment}`
        )
    },
    executeScanTool(configId){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/${configId}/execute-scan`
        )
    },
    executeScanFinding(findingId){
        return makeCancellableAPIRequest(
            "POST",
            `/user/findings/${findingId}/execute-scan`
        )
    },
    getToolsLastConnectedDetails(params) {
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/appsec-tools/last-connected`,
            {
                params
            }
        )
    },
    getOAuthEnabledTools(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant-config?configType=PRIVATE_INSTANCE_CONFIG"
        )
    }

}

export default ToolsIntegrationsAPI;

export const ToolStatusMappingAPI = {
    getToolStatusMapping(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `/api/business-unit-setting/toolConfig/${tool_name}`
        )
    },

    updateToolStatusMapping(data, tool_name){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/business-unit-setting/toolConfig/${tool_name}`,
            {
                data
            }
        )
    },
    createToolStatusMapping(data, tool_name){
        return makeCancellableAPIRequest(
            "POST",
            `/api/business-unit-setting/toolConfig/${tool_name}`,
            {
                data
            }
        )
    },
    getToolStatusAndSeverityUpdateStatus(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tool-settings/${tool_name}`
        )
    },
    postToolStatusAndSeverityUpdateStatus(tool_name, data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tool-settings/${tool_name}`,
            {
                data
            }
        )
    }
}

export const ToolArchiveStateAPI = {
    getToolArchiveStatus(params){
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/generic/sub-product-archiving`,
            {
                params
            }
        )
    },
    
    postToolArchiveStatus(toolName,archiveState){
        return makeCancellableAPIRequest(
            "POST",
            `user/tools/generic/sub-product-archiving?toolName=${toolName}&archiveState=${archiveState}`
        )
    }
}

export const ToolProjectPhasesMappingAPI = {
    getToolProjectPhaseMapping(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/${tool_name}-project-version-phases`
        )
    },

    updateToolProjectPhaseMapping(tool_name, data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/${tool_name}-project-version-phases`,
            {
                data
            }
        )
    }
}

export const ToolStorageSupportAPI = {
    getToolStorageSupportMapping(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/get-${tool_name}-usage-types`,
        )
    },

    updateToolStorageSupportMapping(tool_name, data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/add-${tool_name}-usage-types`,
            {
                data
            }
        )
    }
}

export const ToolRiskReportSupportAPI = {
    getToolRiskReportMapping(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `/api/business-unit-setting/toolConfig/${tool_name}`,
        )
    },
}

export const ToolExcludeScanReportAPI = {
    getWorkFlow(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/generic/${tool_name}-workflows`
        )
    },

    getExcludedWorkFlows(tool_name){
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/generic/${tool_name}-excluded-workflows`
        )
    },

    updateExcludedWorkFlows(tool_name, data){
        return makeCancellableAPIRequest(
            "POST",
            `user/tools/generic/${tool_name}-excluded-workflows`,
            {
                data
            }
        )
    }
}

export const ToolSeverityMappingAPI = {
    getToolSeverityMapping(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/tenant/bu/tools/severityMapping"
        )
    },
    updateToolSeverityMapping(data, id){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/tenant/bu/tools/severityMapping/${id}`,
            {
                data
            }
        )
    },
    createToolSeverityMapping(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/tenant/bu/tools/severityMapping",
            {
                data
            }
        )
    },
    deleteToolSeverityMapping(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/tenant/bu/tools/severityMapping/${id}`
        )
    },
}
export const CustomToolAPI = {
    getCustomTools(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/custom/"
        )
    },
    getCustomToolsConfiguration(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/custom/configurations"
        )
    },
    createCustomTool(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/custom/configurations",
            {
                data
            }
        )
    },
    getCustomTool(id){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/custom/configurations/${id}`,
        )
    },
    updateCustomTool(id, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/custom/configurations/${id}`,
            {
                data
            }
        )
    },
}
export const CoverityIssueKindAPI = {
    getConfiguredIssueKind(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/coverity/issue-kinds",
        )
    },
    getAvailableIssueKind(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/tools/coverity/predefined-issue-kinds",
        )
    },
    updateIssueKind(data){
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/coverity/issue-kinds",
            {
                data
            }
        )
    }
}

export const ToolFindingStatusMappingSupportAPI = {
    getToolMappingStatus(toolName){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tools/${toolName}/finding-status-mapping-toggle`,
        )
    },
    
    postToolMappingStatus(toolName, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/tools/${toolName}/finding-status-mapping-toggle`,
            {
                data
            }
        )
    }
}


export const WhiteHatRiskSupportAPI = {
    getConfiguredRiskSupport(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/business-unit-setting/toolConfig/WhiteHat Sentinel",
        )
    },
    updateRiskSupportMethod(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/business-unit-setting/toolConfig/WhiteHat Sentinel",
            {
                data
            }
        )
    }


}

export const GithubSecretScanSupportAPI = {
    getGithubSecretScanToolConfig(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/business-unit-setting/toolConfig/Github Secret Scan",
        )
    },
    updateGithubSecretScanToolConfig(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/business-unit-setting/toolConfig/Github Secret Scan",
            {
                data
            }
        )
    }


}

export const ToolConfigurationNotesAPI = {
    getToolConfigurationNotes(toolConfigId, page=0){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tools/configuration/${toolConfigId}/notes?page=${page}`
        )
    },
    createToolConfigurationNote(toolConfigId, data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/configuration/${toolConfigId}/notes`,
            {
                data
            }
        )
    },
    updateToolConfigurationNote(toolConfigId, noteId, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/tools/configuration/${toolConfigId}/notes/${noteId}`,
            {
                data
            }
        )
    },
    deleteToolConfigurationNote(toolConfigId, noteId, data){
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/tools/configuration/${toolConfigId}/notes/${noteId}`,
            {
                data
            }
        )
    },
    getToolConfigurationNotesUnreadStats(toolLoginId, activeToolConfigIds){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/login/${toolLoginId}/notes-stats`,
            {"data":activeToolConfigIds}
        )
    },
    setToolConfigurationNoteReadStatus(toolConfigId, noteId, readStatus){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/tools/configuration/${toolConfigId}/notes/${noteId}/notification`,
            {
                "data":{"readStatus": readStatus}
            }
        )
    },
}

export const ToolConfigurationNotesOptInUsersAPI = {
    getToolConfigurationNotesOptInUsers(){
        return makeCancellableAPIRequest(
            "GET",
            `api/business-unit-setting`
        )
    },
    saveToolConfigurationNotesOptInUsers(data){
        return makeCancellableAPIRequest(
            "POST",
            "api/business-unit-setting",
            {
                data: {
                    configType: "TOOL_CONFIG_NOTES_USER_OPT_IN",
                    config: {
                        ...data
                    }
                }
            }
        )
    }
}

export const CheckmarxOneScanFiltersAPI = {
    getConfiguredScanFilters() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/business-unit-setting/toolConfig/Checkmarx One",
        )
    },
    updateScanFilters(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/business-unit-setting/toolConfig/Checkmarx One",
            {
                data
            }
        )
    }
}

export const JfrogXraySeverityFilterAPI = {
    getConfiguredSeverityFilters() {
        return makeCancellableAPIRequest( 
            "GET",
            "/api/business-unit-setting/toolConfig/JFrog Xray",
        )
    },
    updateSeverityFilters(data) { 
        return makeCancellableAPIRequest(
            "POST",
            "api/business-unit-setting/toolConfig/JFrog Xray",
            {
                data
            }
        )
    }    
}

export const EndorLabsBranchTypeFilterAPI = {
    getConfiguredBranchTypeFilter() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/business-unit-setting/toolConfig/Endor Labs",
        );
    },
    updateBranchTypeFilter(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/business-unit-setting/toolConfig/Endor Labs",
            {
                data
            }
        );
    }
};

export const GSCCConfigAPI = {
    getConfig() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/business-unit-setting/toolConfig/GSCC",
        );
    },
    updateConfig(config) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/business-unit-setting/toolConfig/GSCC",
            {
                data: {
                    config
                }
            }
        );
    }
};